import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useCart } from "@/context/CartContext";

const eur = (v) => `€${v.toLocaleString("en-US")}`;

export function ProductImage({ product, className = "" }) {
  if (product.image) {
    return (
      <img
        src={product.image}
        alt={product.name}
        className={`product-media ${className}`}
        loading="lazy"
      />
    );
  }
  // No supplied photograph — branded frame (never an invented product photo)
  return (
    <div className={`flex flex-col items-center justify-center bg-onyx ${className}`}>
      <img src="/brand/monogram.jpg" alt="Beautifully Disturbed" className="w-16 h-16 object-contain opacity-80 mb-5" />
      <span className="label-mono text-smoke">Photography forthcoming</span>
    </div>
  );
}

export default function RelicCard({ product, index = 0 }) {
  const { addItem, setOpen } = useCart();
  const preorder = (product.stock ?? 0) <= 0;

  return (
    <motion.article
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay: (index % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
      className="group"
      data-testid={`relic-card-${product.slug}`}
    >
      <Link to={`/product/${product.slug}`} className="block">
        <div className="relative overflow-hidden bg-ink aspect-[4/5] mb-6">
          <ProductImage product={product} className="w-full h-full" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent pointer-events-none" />
          {preorder && (
            <span
              className="absolute top-4 left-4 label-mono bg-ink/70 backdrop-blur-sm text-blood border border-blood/50 px-3 py-1.5"
              data-testid={`preorder-badge-${product.slug}`}
            >
              Pre-Order
            </span>
          )}
          <span className="absolute bottom-5 right-5 font-mono text-[11px] tracking-[0.2em] text-ivory/70">
            {product.volume}
          </span>
        </div>
      </Link>
      <div className="flex items-start justify-between gap-4">
        <div>
          <Link to={`/product/${product.slug}`}>
            <h3 className="heading-serif text-2xl md:text-[1.7rem] leading-tight hover:text-blood transition-colors">
              {product.name}
            </h3>
          </Link>
          <p className="text-sm text-smoke mt-2 font-sans max-w-[26ch] leading-snug">{product.tagline}</p>
        </div>
        <span className="font-mono text-sm pt-2 whitespace-nowrap">{eur(product.price)}</span>
      </div>
      <button
        onClick={() => {
          addItem(product);
          setOpen(true);
        }}
        data-testid={`add-to-cart-${product.slug}`}
        className={`btn-relic mt-6 w-full ${
          preorder
            ? "border-blood text-blood hover:bg-blood hover:text-ivory"
            : "border-smoke/40 text-ivory hover:border-blood hover:text-blood"
        }`}
      >
        {preorder ? "Pre-Order" : "Add to Bag"}
      </button>
    </motion.article>
  );
}
